import { createSlice } from "@reduxjs/toolkit";
import axios from "../../lib/axios";
import { toast } from "react-toastify";
import { generateQueryParams } from "../../lib/utils";
const initialState = {
  page: 0,
  rowsPerPage: 10,
  totalDeposits: 0,
  data: [],
  filters: {},
  loading: false,
  error: null,
};

const UserDepositList = createSlice({
  name: "depositlist",
  initialState,
  reducers: {
    requestStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    DSuccess: (state, action) => {
      state.data = action.payload.deposits;
      state.totalDeposits = action.payload.totalDeposits;
      state.loading = false;
      state.error = null;
    },
    updateDeposit: (state, action) => {
      const index = state.data.findIndex((r) => r._id === action.payload._id);
      if (index !== -1) {
        state.data[index] = action.payload;
      }
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
    setFilters: (state, action) => {
      state.filters = action.payload;
    },
    requestFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.data = [];
    },
  },
});

// Actions
export const {
  requestStart,
  DSuccess,
  requestFailure,
  setPage,
  setFilters,
  setRowsPerPage,
  updateDeposit,
} = UserDepositList.actions;

export const GetDepositlist = (page, limit, filters) => async (dispatch) => {
  try {
    dispatch(requestStart());

    const GetDepositlist = await axios.get(
      `/private/backend/deposits?${generateQueryParams({
        ...filters,
        page,
        limit,
      })}`
    );

    if (GetDepositlist?.data) {
      dispatch(DSuccess(GetDepositlist?.data));
    }
  } catch (err) {
    // Handle errors
    toast.error(err?.response?.data?.message || err.message || " failed!");
    dispatch(
      requestFailure(err?.response?.data?.message || "Something went wrong!")
    );
  }
};

export default UserDepositList.reducer;
